import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Link from 'valuelink';
import { Popconfirm, message, Button, DatePicker, Checkbox } from 'antd';
import { Input } from 'valuelink/lib/tags';
import moment from 'moment';
import { RegularText, SemiboldText } from '../../components/common/Text';
import { setDoctorProfile } from '../../actions/index';
import {
  fetchDoctorExperience,
  deleteExperience,
  updateExperience,
} from '../../services';

const { RangePicker } = DatePicker;

const OuterContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
`;

const DepartmentText = styled(SemiboldText)`
  font-size: 1.5rem;
  text-align: center;
  color: #666569;
`;

const ColContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const BodyContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 20px;
  /* over */
`;

const StyledInputBox = styled(Input)`
  font-size: 16px !important;
  background-color: #f8f8f8;
  align-self: stretch;
  border-radius: 6px;
  flex: 1;
  flex-shrink: 0;
  min-width: 180px;
  /* max-width: 380px; */
  height: 44px;
  padding: 6px 12px;
  align-items: center;
`;

const LabelText = styled(SemiboldText)`
  font-size: 12px;
  text-align: center;
  margin-bottom: 0.25rem;
  margin-top: 0.625rem;
  color: #7c7c7c;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
`;

const ExperienceRow = styled.div`
  display: flex;
  flex-direction: row;
  margin: 16px;
  padding: 8px;
  box-shadow: 0 3px 5px 2px rgba(0, 0, 0, 0.1);
  border-radius: 0.5rem;
  align-items: center;
  justify-content: space-between;
`;

const ExperienceNumber = styled(SemiboldText)`
  font-size: 16;
  color: #666569;
`;

const ExperienceInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const ExperienceText = styled(RegularText)`
  font-size: 14;
  color: #666569;
  margin: 0px 10px 0px 10px;
`;

const EduRowComponent = styled.div`
  display: flex;
  flex-direction: row;
`;

class DoctorExperienceScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      experiences: [],
      doctorExperienceId: null,
      department: '',
      designation: '',
      location: '',
      current: '',
      fromDate: '',
      toDate: '',
      formEditing: false,
    };
    console.log({ props });

    this.doctorId = props.doctorId;
  }

  componentDidMount = () => {
    this.fetchExperience();
  };

  fetchExperience = () => {
    const { dispatch } = this.props;
    fetchDoctorExperience(this.doctorId).then(res => {
      const experiences = res.data;
      dispatch(setDoctorProfile({ experiences }));
      this.setState({
        experiences,
      });
    });
  };

  submit = () => {
    const {
      doctorExperienceId,
      department,
      designation,
      location,
      current,
      fromDate,
      toDate,
    } = this.state;

    updateExperience({
      doctorId: this.doctorId,
      doctorExperienceId,
      department,
      designation,
      location,
      current,
      fromDate,
      toDate,
    })
      .then(() => {
        this.cancelEditing();
        this.fetchExperience();
      })
      .catch(err => {
        console.log({ err });
      });
  };

  deleteExperience = doctorExperienceId => {
    deleteExperience(this.doctorId, doctorExperienceId)
      .then(() => {
        message.success('Experience deleted successfully');
        this.fetchExperience();
      })
      .catch(err => {
        console.log({ err });
      });
  };

  editExperience = edu => {
    this.setState({
      formEditing: true,
      doctorExperienceId: edu.doctorExperienceId,
      department: edu.department || '',
      designation: edu.designation || '',
      location: edu.location || '',
      current: edu.current || '',
      fromDate: edu.fromDate || '',
      toDate: edu.toDate || '',
    });
  };

  cancelEditing = () => {
    this.setState({
      formEditing: false,
      doctorExperienceId: null,
      department: '',
      designation: '',
      location: '',
      current: '',
      fromDate: '',
      toDate: '',
    });
  };

  onFromToDateChange = (date, dateString) => {
    console.log({ date, dateString });
    this.setState({
      fromDate: dateString[0],
      toDate: dateString[1],
    });
  };

  onCurrentChange = e => {
    console.log(`checked = ${e.target.checked}`);
    this.setState({
      current: e.target.checked,
    });
  };

  componentDidUpdate = () => {
    if (document.getElementById('edit-form')) {
      document.getElementById('edit-form').scrollIntoView();
    }
  };

  render() {
    const { experiences } = this.state;
    const departmentLink = Link.state(this, 'department');
    const designationLink = Link.state(this, 'designation');
    const locationLink = Link.state(this, 'location');

    const experiencesForm = () => {
      console.log({ state: this.state });
      return (
        <ExperienceRow id="edit-form">
          <BodyContainer>
            <LabelText>Experience Department</LabelText>
            <StyledInputBox
              className="visit-input"
              valueLink={departmentLink}
              placeholder="Department"
            />

            <LabelText>Designation</LabelText>
            <StyledInputBox
              className="visit-input"
              valueLink={designationLink}
              placeholder="designation"
            />

            <LabelText>Location</LabelText>
            <StyledInputBox
              className="visit-input"
              valueLink={locationLink}
              placeholder="location"
            />

            <Checkbox
              style={{ marginTop: 10 }}
              checked={this.state.current}
              onChange={this.onCurrentChange}
            >
              Currently Working here
            </Checkbox>

            <LabelText>From Date - To Date</LabelText>
            <RangePicker
              onChange={this.onFromToDateChange}
              style={{ marginBottom: 20 }}
              defaultValue={
                this.state.fromDate
                  ? [
                      moment(this.state.fromDate, 'YYYY-MM-DD'),
                      moment(this.state.toDate, 'YYYY-MM-DD'),
                    ]
                  : null
              }
            />

            <EduRowComponent>
              <Button
                type="primary"
                style={{ marginRight: 10 }}
                onClick={this.submit}
              >
                Submit
              </Button>
              <Button onClick={this.cancelEditing}>Cancel</Button>
            </EduRowComponent>
          </BodyContainer>
        </ExperienceRow>
      );
    };

    const renderExperience = (edu, idx) => (
      <ExperienceRow>
        <EduRowComponent>
          <ExperienceNumber>{idx + 1}. </ExperienceNumber>
          <ExperienceInfo>
            <ExperienceText>{`${edu.designation}, From: ${edu.fromDate} To:${edu.toDate}`}</ExperienceText>
            <ExperienceText>{edu.location}</ExperienceText>
          </ExperienceInfo>
        </EduRowComponent>
        <EduRowComponent>
          <Button
            type="primary"
            style={{ marginRight: 10 }}
            onClick={() => this.editExperience(edu)}
          >
            Edit
          </Button>
          <Popconfirm
            department="Are you sure delete this?"
            onConfirm={() => this.deleteExperience(edu.doctorExperienceId)}
            // onCancel={cancel}
            okText="Yes"
            cancelText="No"
          >
            <Button type="danger">Delete</Button>
          </Popconfirm>
        </EduRowComponent>
      </ExperienceRow>
    );

    return (
      <OuterContainer>
        <DepartmentText>Doctor Experience Screen</DepartmentText>
        <ColContainer>{experiences.map(renderExperience)}</ColContainer>
        {!this.state.formEditing && (
          <Button
            style={{ alignSelf: 'center', flex: 0, padding: 4 }}
            onClick={() => this.editExperience({})}
          >
            Add Experience
          </Button>
        )}
        {this.state.formEditing && experiencesForm()}
      </OuterContainer>
    );
  }
}

const mapStateToProps = state => ({
  authToken: state.user.authToken,
});

export default connect(mapStateToProps)(DoctorExperienceScreen);
